import React, { useEffect } from 'react'
import Home from "../../components/Home/index"
import { useNavigate, useParams } from 'react-router-dom'

const Index = () => {
    const navigate = useNavigate()

    useEffect(() => {
        if (!localStorage.getItem("bentoAdmin")) {
            navigate("/login")
        }
    }, [navigate])

    const { types } = useParams()

    return (
        <div className='flex-1 flex flex-col min-h-0 w-full overflow-hidden bg-gray-50'>
            <Home type={types} />
        </div>
    )
}

export default Index